import React from 'react'
import _ from 'lodash'

import {Grid, Row, Col} from 'react-flexbox-grid'

import {NetworkStore, NetworkService} from 'api/network'
import {AuthStore} from 'api/auth'
import {NotFound} from 'bundle/dashboard/network/NotFound.jsx'
import {AccessDenied} from 'bundle/dashboard/network/AccessDenied.jsx'

export class NetworksStorage extends React.Component {
   static get propTypes() {
      return {
         children: React.PropTypes.node.isRequired
      }
   }

   constructor() {
      super()
      this.state = {networks: NetworkStore.networks}

      this._mounted = null
   }

   componentWillMount() {
      this._mounted = true

      NetworkService.list()

      NetworkStore.addChangeListener(
         (this._listener = () => {
            if (this._mounted) {
               this.setState({networks: NetworkStore.networks})
            }
         }),
      )
   }

   componentWillUnmount() {
      this._mounted = false
      NetworkStore.removeChangeListener(this._listener)
   }

   render() {
      let {networks} = this.state,
         {children, ...props} = this.props

      return React.cloneElement(children, {...props, networks: networks})
   }
}

export class NetworkStorage extends React.Component {
   static get propTypes() {
      return {
         children: React.PropTypes.node.isRequired,
         nid:      React.PropTypes.string,
         Sidebar:  React.PropTypes.any
      }
   }

   constructor(props) {
      super(props)
      this.state = {network: NetworkStore.network(props.nid)}
   }

   componentWillMount() {
      let network = null

      this._mounted = true

      network = NetworkStore.network(this.props.nid)

      if (!network && this.props.nid) {
         NetworkService.fetch(this.props.nid)
      }

      NetworkStore.addChangeListener(
         (this._listener = () =>
            this._mounted && this.setState({network: NetworkStore.network(this.props.nid)})),
      )
   }

   componentWillUnmount() {
      this._mounted = false
      NetworkStore.removeChangeListener(this._listener)
   }

   componentWillReceiveProps(next) {
      let network = null

      if (next.nid !== this.props.nid) {
         network = NetworkStore.network(next.nid)

         if (!network && next.nid) {
            NetworkService.fetch(next.nid)
         }

         this.setState({network: network})
      }
   }

   render() {
      let {network} = this.state,
         {children, Sidebar, nid, ...props} = this.props,
         hasSidebar = _.isFunction(Sidebar)

      if (network) {
         if (AuthStore.canAccess('network', network)) {
            return React.cloneElement(children, {...props, network: network})
         } else {
            return (
               <Grid>
                  <Row style={{padding: '2rem 0'}}>
                     {hasSidebar &&
                        <Col className="sidebar" xs={4}>
                           <Sidebar nid={nid} {...props} />
                        </Col>}

                     <Col className="main" xs={hasSidebar ? 8 : 12}>
                        <AccessDenied nid={nid} network={nid} />
                     </Col>
                  </Row>
               </Grid>
            )
         }
      } else {
         return (
            <Grid>
               <Row style={{padding: '2rem 0'}}>
                  {hasSidebar &&
                     <Col className="sidebar" xs={4}>
                        <Sidebar nid={nid} {...props} />
                     </Col>}

                  <Col className="main" xs={hasSidebar ? 8 : 12}>
                     <AccessDenied nid={nid} network={nid} />
                  </Col>
               </Row>
            </Grid>
         )
      }
   }
}



// WEBPACK FOOTER //
// lib/storage/Network.jsx